/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_ImpersonatedInputs */



/**
* | output |
* | --- |
* | "You are signed in as someone else. Practice conversations can only be opened from your own account." |
*
* @param {Practice_Session_ImpersonatedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_impersonated = /** @type {((inputs?: Practice_Session_ImpersonatedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_ImpersonatedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je bent ingelogd als iemand anders. Oefengesprekken openen kan alleen vanuit je eigen account.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes connecté sous l'identité d'une autre personne. Vous ne pouvez ouvrir les entretiens d'entraînement que depuis votre propre compte.")
	return /** @type {LocalizedString} */ ("You are signed in as someone else. Practice conversations can only be opened from your own account.")
});